module.exports = __webpack_public_path__ + "static/media/indexPageImg.d0f67888.png";